import * as React from "react";
import type { SVGProps } from "react";
const SvgIcEdit = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 18 18"
    {...props}
  >
    <path
      stroke="#02066E"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M11.317 3.857a1 1 0 0 1 1.414 0l1.411 1.41a1 1 0 0 1 0 1.414l-7.237 7.242a1 1 0 0 1-.51.273l-3.245.654.655-3.241a1 1 0 0 1 .273-.509z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgIcEdit;
